// src/lib/backHandlers.ts
// Stack of hardware-back handlers. Mounted drawers/modals own registration and cleanup;
// a busy modal keeps consuming repeated presses until it can close.
// UI elements (drawers, modals) push a handler
// when they open; the topmost is run first when Android back is pressed.
// Returning `false` from a handler means "did not handle"; anything else (incl.
// undefined) means "handled, stop propagation".
import { create } from 'zustand';

export type BackHandler = () => boolean | void;

interface BackHandlerStore {
  handlers: BackHandler[];
  push: (h: BackHandler) => () => void;
  runTop: () => boolean;
}

export const useBackHandlerStore = create<BackHandlerStore>((set, get) => ({
  handlers: [],
  push: (h) => {
    set((s) => ({ handlers: [...s.handlers, h] }));
    return () => set((s) => ({ handlers: s.handlers.filter((x) => x !== h) }));
  },
  runTop: () => {
    const stack = get().handlers;
    if (stack.length === 0) return false;
    const top = stack[stack.length - 1];
    const result = top();
    return result !== false;
  },
}));
